import millionaireCircle from './millionaireCircle';
import erc from './erc20';
import earningPayer from './earningPayer';
import { otcMarketplaceAbi } from './otcMarketplace';

export default { millionaireCircleAbi: millionaireCircle, erc20Abi: erc, earningPayer, otcMarketplaceAbi };
